import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import BgImg from "../../images/locationgcc/dubai_new/zero_hassle_back.webp";

function Zerohassle() {
  return (
    <section
      className="redefinepatient_services zero_hassle_dubai p-100 tekgrip_section"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Our Zero-Hassle Process for Mobile App Development in Dubai</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Over time, our tech-driven mobile app development company in Dubai
              has refined and automated the process to build custom Android and
              iOS solution for quicker turnarounds and secure applications for
              users across UAE. With agile development frameworks and AI
              -powered testing, we cut short time-to-market, helping startups
              and enterprises reach customers fasters with personalized
              experiences.
            </p>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={6} lg={4} xl={4} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            01. Project Consultation
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            02. Product Strategy Planning
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">03. UX/UI Design</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="3">
                            04. Core App Development
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="4">
                            05. Feedback & Iterations
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="5">
                            06. Content Integration
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="6">
                            07. Quality Assurance Phase
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="7">
                            08. Launch & Deployment
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={6} lg={8} xl={8}>
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <p>
                          Our expert app developers in Dubai engage with our
                          clients to thoroughly understand their requirements.
                          This scoping session, overseen by our technical
                          consultants, aims to identify and streamline the
                          optimal technologies, development methodologies, and
                          other critical factors for the success of your mobile
                          application. The requirement analysis phase includes:
                        </p>
                        <ul>
                          <li>Market Research</li>
                          <li>Streamlining Technologies</li>
                          <li>Feasibility Study</li>
                          <li>Competitor Analysis</li>
                          <li>Scope Assessment</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <p>
                          Once the requirements are understood by our mobile app
                          developers in UAE, a strategic plan is developed right
                          after the initial scoping, brainstorming,
                          conceptualization, pre-development prep, and other
                          processes are completed. This strategic plan describes
                          the best app development approach that our app
                          development company in Dubai will take and the time
                          that will be required to develop your application. In
                          a nutshell, here's what you can expect in this phase:
                        </p>
                        <ul>
                          <li>Identifying Product's Objective</li>
                          <li>TAM Finalization</li>
                          <li>Product Development & Designing</li>
                          <li>Product Delivery & Launch</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <p>
                          The design phase is the part where an initial design
                          (Screens, UI/UX, Visuals, Aesthetics, Etc.) is created
                          and sent to the concerned individual for approval.
                          Meetings can also be scheduled to review the design of
                          the mobile application. Any suggestions, feedback, or
                          recommendations are recorded during this process, and
                          corrections are made before moving on to the next
                          phase, which is development. Like any other app
                          development phase, this phase also includes various
                          stages, i.e.:
                        </p>
                        <ul>
                          <li>Designing Sketches</li>
                          <li>Wireframing</li>
                          <li>Design Mock-ups</li>
                          <li>Prototyping & Designing</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <p>
                          In the development phase, our expert app developers in
                          Dubai build the functionality of your product. For
                          cross-platform apps, we typically start with Android
                          development due to its easier build, test, and
                          deployment process. After developing both Android and
                          iOS versions, the apps undergo initial testing for
                          performance and functionality. Key aspects of this
                          phase include:
                        </p>
                        <ul>
                          <li>Custom Application Development</li>
                          <li>Integration of Latest Technologies</li>
                          <li>Ensuring Robustness & Scalability</li>
                          <li>Completion of Source Codes & IP Rights</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="4">
                        <p>
                          This phase involves presenting the mobile application
                          to the client for valuable feedback. The app is
                          showcased only after thorough testing for
                          functionality and performance. As the leading app
                          development company in Dubai, we aim for a 70%
                          approval rate initially, with further changes made
                          based on client directions.
                        </p>
                        <ul>
                          <li>Collect Client Feedback</li>
                          <li>Identify Areas for Improvement</li>
                          <li>Implement Client Suggestions</li>
                          <li>Conduct Follow-up Reviews</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="5">
                        <p>
                          After passing the feedback phase, we incorporate your
                          content into the app. Our seasoned app developers in
                          Dubai ensure that the content aligns perfectly with
                          the app design, enhancing the overall user experience.
                        </p>
                        <ul>
                          <li>Align Content with App Design</li>
                          <li>Ensure Content Consistency and Quality</li>
                          <li>Optimize Content for User Engagement</li>
                          <li>Incorporate Multilingual Support</li>
                        </ul>
                      </Tab.Pane>

                      <Tab.Pane eventKey="6">
                        <p>
                          Led by our top QA engineers and specialists, the
                          quality assurance phase involves rigorous testing of
                          the app for usability, performance, functionality, and
                          compatibility across multiple devices. Bugs, errors,
                          and lags are identified and addressed to ensure the
                          highest quality. Once our QA team approves, we present
                          the finalized version to you.
                        </p>
                        <ul>
                          <li>Usability Testing</li>
                          <li>Performance and Load Testing</li>
                          <li>Functionality Testing</li>
                          <li>Cross-Device Compatibility Checks</li>
                          <li>Identify and Fix Bugs and Errors</li>
                          <li>Final Approval from QA Team</li>
                        </ul>
                      </Tab.Pane>

                      <Tab.Pane eventKey="7">
                        <p>
                          Upon your approval, we submit the app to the Play
                          Store and App Store for approval and publishing.
                          Post-launch, our Android and iOS mobile app developers
                          in Dubai, UAE focus on updates based on user feedback,
                          ensuring your app remains robust and up-to-date.
                          Additional aspects of this phase include:
                        </p>
                        <ul>
                          <li>Optimizing Your App's Presence</li>
                          <li>Dedicated Customer Service Assistance</li>
                          <li>Software Licensing and Compliance </li>
                        </ul>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Zerohassle;
